/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { keyframes } from '@emotion/react'
import React from 'react'
import colors from '@sportninja/common/constants/appColors'
import { SCOPE_CONTROL_HEIGHT } from '../constants/registrationScopeRow'

// Read SECONDARY_350 (absent from the typed appColors inference) via a cast,
// the pattern PlayerFormSkeleton uses for the same bar.
const palette = colors as Record<string, string>

/** Stands in for the Season picker while its seasons are on their first load. */
const RegistrationSeasonSkeleton: React.FC = () => (
  <div
    css={barStyle}
    aria-hidden='true'
    data-testid='registration-season-skeleton'
  />
)

export default RegistrationSeasonSkeleton

// ---- styled ----
// The house pulse (PlayerFormSkeleton).
const pulse = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 0.9; }
  100% { opacity: 0.5; }
`

// The Season picker's footprint, so the row does not jump when it lands.
const barStyle = css`
  width: 300px;
  max-width: 100%;
  height: ${SCOPE_CONTROL_HEIGHT}px;
  border-radius: 8px;
  background-color: ${palette.SECONDARY_350};
  animation: ${pulse} 1.4s ease-in-out infinite;
`
